import { render } from "./DashboardNavbar.vue?vue&type=template&id=01986830&scoped=true&ts=true"
import script from "./DashboardNavbar.vue?vue&type=script&lang=ts"
export * from "./DashboardNavbar.vue?vue&type=script&lang=ts"

import "./DashboardNavbar.vue?vue&type=style&index=0&id=01986830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01986830"]])

export default __exports__